import React, {
  useState,
  Fragment,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import "./styles.css";

import { ReactComponent as CancelIcon } from "common/assets/svg/cancel.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "common/rootReducer";
import { CURRENT_CHECKIN_RESERVATION_ID } from "common/constants";
import { getBooking } from "common/features/checkIn/checkInActions";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { hideFloatingReservation } from "common/features/checkIn/checkInActions";
import {
  startEmptyCart,
  hideFloatingCart,
  showFloatingCart,
} from "common/features/cart/cartActions";
import ConfirmationPrompt from "components/prompts/confirmationPrompt";
import { getPlaceOrderURL } from "common/utils/route-util";
import { ReactComponent as INRIcon } from "common/assets/svg/inr.svg";
import { usePlaceOrder } from "hooks/usePlaceOrder";
import { OrderType } from "common/features/user/userModels";
import { startEmptyCartOrder } from "common/features/order/orderActions";

function CartStatusCard() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [
    makeOrder,
    totalItemsubTotal,
    totalOrderPrice,
    totalTaxAndCharges,
    totalItemTaxAmount,
    tipAmount,
    packagingCharge,
    discountAmount,
  ] = usePlaceOrder();
  let { merchantType, restaurantSlug, menuType, merchantSlug, tableId } =
    useParams<any>();
  const cartRestaurantSlug = useSelector(
    (state: RootState) => state.cart.cartRestaurantSlug
  );
  const restaurantDetails = useSelector(
    (state: RootState) => state.restaurant?.currentRestaurantDetail
  );
  const restaurantOrderTypeId = useSelector(
    (state: RootState) => state.restaurant?.restaurantOrderTypeId
  );
  const restaurantOrderTypes = useSelector(
    (state: RootState) => state.restaurant?.currentRestaurantDetail?.orderTypes
  );

  const cartMenuType = useSelector(
    (state: RootState) => state.cart.cartMenuType
  );
  const cartMerchantType = useSelector(
    (state: RootState) => state.cart.merchantType
  );

  const showCart = useSelector(
    (state: RootState) => state.cart.showFloatingCart
  );

  const itemsAvailable = useSelector(
    (state: RootState) => state.cart.cart.items.length > 0
  );

  const currentRestaurantMenuType = useSelector(
    (state: RootState) => state.restaurant.currentMenuType
  );

  let minOrderAmount = restaurantDetails?.orderTypes?.find(
    (name) => name.typeName === currentRestaurantMenuType
  );

  let orderType = restaurantDetails?.orderTypes?.filter(
    (orderType) => orderType.typeGroup == "D"
  )[0];

  const eventDate = useSelector((state: RootState) => state.cart.eventDate);


  // Can be used to configure the list of routes where the status card has to be shown.
  const cartStatusCardRoutes = [
    `/restaurant/${cartRestaurantSlug}/menu/${cartMenuType}`,
    `/salon/${cartRestaurantSlug}/menu/${cartMenuType}`,
    `/restaurant/${cartRestaurantSlug}/menu/${cartMenuType}/`,
    `/restaurant/${cartRestaurantSlug}/menu/${cartMenuType}/e/${eventDate}`,
    `/restaurant/${cartRestaurantSlug}/menu/${cartMenuType}/event/${eventDate}`,
  ];
  const isCartRoute = cartStatusCardRoutes.some((cartRoute) => {
    return (
      location.pathname == cartRoute ||
      (location.pathname.includes("table") &&
        !location.pathname.includes("customize") &&
        orderType &&
        location.pathname.includes(orderType?.typeName))
    );
  });
  const [open, setOpenPrompt] = useState(false);
  const isContactlessDineInOrder = useMemo(() => {
    return (
      window.location.pathname.includes("table") &&
      (restaurantDetails.dining == 2 || restaurantDetails.dining == 3)
    );
  }, [restaurantDetails]);

  useEffect(() => {
     //console.log({itemsAvailable,isCartRoute},'fs', location.pathname, );
    if (!itemsAvailable || !isCartRoute) {
      dispatch(hideFloatingCart());
    } else {
      dispatch(showFloatingCart());
    }
  }, [itemsAvailable,isCartRoute]);

  const getImageURL = useCallback(
    (type: string) => {
      if (restaurantDetails.media.length > 0) {
        const logoMedia = restaurantDetails?.media?.filter(
          (media) => media?.entityType == type
        )[0];

        return (
          process.env.REACT_APP_IMAGE_URL +
          logoMedia.mimeType.split("/")[0] +
          "/" +
          logoMedia.id +
          "." +
          logoMedia.mimeType.split("/")[1]
        );
      } else {
        return "";
      }
    },
    [restaurantDetails]
  );

  const showPrompt = () => {
    setOpenPrompt(true);
  };

  const submitPrompt = (answer: boolean) => {
    answer &&
      dispatch(
        startEmptyCart({
          menuType: cartMenuType,
          restaurantSlug: cartRestaurantSlug,
          clearCartItems: true,
          merchantType: "restaurant",
        })
      );
      dispatch(startEmptyCartOrder())

    setOpenPrompt(false);
  };
//isCartRoute &&
  return (
    <Fragment>
      {showCart && !isContactlessDineInOrder && window.innerWidth <= 500 ? (
        <div>
          <ConfirmationPrompt
            question={
              " Are you sure you want to remove all the items that you’ve added to the cart ?"
            }
            isOpen={open}
            submitPrompt={submitPrompt}
            submitText={"REMOVE"}
            cancelText={"CANCEL"}
            InfoImage={null}
            type={"prompt"}
          />
          <div className="cart-status-row">
            {minOrderAmount &&
              minOrderAmount.minOrderAmount > 0 &&
              totalItemsubTotal < minOrderAmount.minOrderAmount && (
                <span className="minimun-value-container">
                  <span> Minimum item value must be </span> &nbsp; &nbsp;
                  <span className="price-text">
                    <INRIcon /> &nbsp;
                    {minOrderAmount.minOrderAmount}
                  </span>
                  {/* {minOrderAmount.minOrderAmount} */}
                </span>
              )}

            <div className="cart-status-container">
              <div
                className="name-logo-container"
                onClick={() => {
                  history.push(
                    getPlaceOrderURL(
                      cartMerchantType,
                      cartRestaurantSlug,
                      cartMenuType
                    )
                  );
                }}
              >
                <div className="cart-logo-container">
                  <img
                    src={getImageURL("LOGO")}
                    className="logo-cart"
                    alt="logo"
                  />
                </div>
                <div className="name-container">
                  <span id="cart-status-name">
                    {restaurantDetails.branchName.split(",")[0]}
                  </span>
                  <span id="cart-status-msg">You have items in your cart</span>
                </div>
              </div>

              <div className="view-closeIcon-container">
                <span
                  className="view-text"
                  onClick={() => {
                    if (location.pathname.includes("table")) {
                      history.push({
                        pathname: getPlaceOrderURL(
                          cartMerchantType,
                          cartRestaurantSlug,
                          cartMenuType
                        ),
                        state: { query: "tableSide" },
                      });
                    } else {
                      history.push(
                        getPlaceOrderURL(
                          cartMerchantType,
                          cartRestaurantSlug,
                          cartMenuType
                        )
                      );
                    }
                  }}
                >
                  View
                </span>

                <span
                  className="closeIcon-container"
                  onClick={() => {
                    showPrompt();
                  }}
                >
                  <CancelIcon
                    id="cart-status-cancel-icon"
                    onClick={() => showPrompt()}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : // </div>
      null}
    </Fragment>
  );
}

export default CartStatusCard;
